if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.formInput = this.form?.querySelector("[name=id]");
        if (this.formInput) this.formInput.disabled = false;
        this.form?.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart = document.querySelector("cart-drawer");
        this.cartType = this.cart?.dataset.cartType;

        this.submitButton = this.querySelector('[type="submit"]');
        this.body = document.querySelector("body");

        if (document.querySelector("cart-drawer"))
          this.submitButton?.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";

        this.handleErrorMessage = this.handleErrorMessage.bind(this);
        this.redirectAfterSubmit = this.redirectAfterSubmit.bind(this);
        this.disableLoadingInButton = this.disableLoadingInButton.bind(this);
      }

      closeComplementaryProduct() {
        const complementaryOverlayPage = document.querySelector(
          ".wt__quick-buy--page-overlay",
        );
        if (this.body.classList.contains("quick-buy-page-overlay"))
          this.body.classList.remove("quick-buy-page-overlay");
        if (
          complementaryOverlayPage.classList.contains(
            "wt__quick-buy--page-overlay--open",
          )
        )
          complementaryOverlayPage.classList.remove(
            "wt__quick-buy--page-overlay--open",
          );
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        const sofaBedOptions = this.closest("section")?.querySelector("variant-sofa-bed-options");
        if (sofaBedOptions && !sofaBedOptions.validateSelection()) {
          this.handleErrorMessage("Please choose the available sofa bed options.");
          return;
        }
        sofaBedOptions?.applySelection(this.form);

        const ladderSide = this.closest("section")?.querySelector("variant-ladder-side");
        if (ladderSide && !ladderSide.validateSelection()) {
          this.handleErrorMessage("Please choose a left-hand or right-hand ladder.");
          return;
        }
        ladderSide?.applySelection(this.form);

        const ottomanOpening = this.closest("section")?.querySelector("variant-ottoman-opening");
        if (ottomanOpening && !ottomanOpening.validateSelection()) {
          this.handleErrorMessage("Please choose an ottoman opening side.");
          return;
        }
        ottomanOpening?.applySelection(this.form);

        const ladderOffer = this.closest("section")?.querySelector("ladder-clearance-offer[data-ladder-clearance-offer]");
        if (ladderOffer) {
          const ladderChoice = await ladderOffer.choose(this.form.querySelector("[name=id]")?.value);
          if (!ladderChoice) return;
          ladderOffer.applyChoice(this.form, ladderChoice);
        }

        this.handleErrorMessage();
        this.cart?.setActiveElement(document.activeElement);

        const loader = this.querySelector(".loading-overlay__spinner");

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        if (loader) loader.classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        const productVariantId = formData.get("id");
        const customizer = this.closest("section")?.querySelector(
          'native-product-customization[data-enabled="true"]',
        );
        const sectionIds = this.cart
          ?.getSectionsToRender()
          .map((section) => section.id) || [];

        if (customizer) {
          const metadata = customizer.selectedVariantMetadata();
          if (metadata.status === "unavailable") {
            this.handleErrorMessage("This option is currently unavailable.");
            this.disableLoadingInButton();
            return;
          }

          const groupId =
            globalThis.crypto?.randomUUID?.() ||
            `rb-${Date.now()}-${Math.random().toString(16).slice(2)}`;
          const properties = { _addon_group_id: groupId };
          if (metadata.leadDays !== "") properties._lead_time_days = metadata.leadDays;
          if (metadata.note) properties._availability_note = metadata.note.slice(0, 255);
          if (metadata.status) properties._availability_status = metadata.status;
          if (metadata.drawerSelection) properties.Drawers = metadata.drawerSelection;

          formData.forEach((value, key) => {
            const propertyMatch = key.match(/^properties\[(.+)\]$/);
            if (propertyMatch && value !== "") properties[propertyMatch[1]] = value;
          });

          const mainItem = {
            id: Number(productVariantId),
            quantity: Math.max(1, Number.parseInt(formData.get("quantity") || "1", 10) || 1),
            properties,
          };
          if (formData.get("selling_plan")) mainItem.selling_plan = Number(formData.get("selling_plan"));

          config.headers["Content-Type"] = "application/json";
          config.body = JSON.stringify({
            items: [mainItem, ...customizer.selectedItems(groupId)],
            sections: sectionIds,
            sections_url: window.location.pathname,
          });
        } else {
          formData.append("sections", sectionIds);
          formData.append("sections_url", window.location.pathname);
          config.body = formData;
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              this.error = true;

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId,
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.redirectAfterSubmit(response);
                  });
                },
                { once: true },
              );
              if (this.cartType === "drawer") quickAddModal.hide(true);
            } else {
              const isClosedCart = !document.body.classList.contains(
                "page-overlay-cart-on",
              );
              this.redirectAfterSubmit(response, isClosedCart);
            }
          })
          .catch((e) => {
            console.error(e);
            if (e instanceof TypeError && e.message.includes("'cart-drawer'")) {
              location.reload();
            }
          })
          .finally(() => {
            if (this.cartType === "page") {
              if (this.error) this.disableLoadingInButton();
              return;
            }
            this.disableLoadingInButton();
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            if (this.error) return;
            this.quick_add_container = document.querySelector(
              ".wt__quick-buy__container",
            );
            this.quick_add_overlay = document.querySelector(
              ".wt__quick-buy--page-overlay",
            );
            this.quick_add_product =
              this.quick_add_container.querySelector(".wt-product");
            this.loader = this.quick_add_container.querySelector(
              ".wt__quick-buy-loader",
            );

            if (!this.quick_add_container.classList.contains("hidden")) {
              // use handle and quickbuy closeCart()

              this.quick_add_product?.remove();
              this.quick_add_container.classList.remove(
                "wt__quick-buy__container--open",
              );
              this.quick_add_overlay.classList.remove(
                "wt__quick-buy--page-overlay--open",
              );
              document.body.classList.remove("quick-buy-page-overlay");
              this.loader.classList.remove("hidden");
            }
          });
      }

      disableLoadingInButton() {
        this.submitButton.classList.remove("loading");
        this.querySelector(".loading-overlay__spinner").classList.add("hidden");
      }

      redirectAfterSubmit(response, isClosedCart = true) {
        const body = document.body;
        const isCartPage = body.classList.contains("template-cart");

        if (this.cartType === "drawer" && isCartPage) {
          const overlay = document.querySelector(
            ".wt__quick-buy--page-overlay",
          );
          overlay.classList.remove("wt__quick-buy--page-overlay--open");
          body.classList.remove("quick-buy-page-overlay");
        } else if (this.cartType === "drawer") {
          this.cart.renderContents(response, isClosedCart);
          return;
        }
        window.location = window.routes.cart_url;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message",
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    },
  );
}
